// extracted by mini-css-extract-plugin
export default {"imageWrapper":"rM-z","twoColumnImage":"sM-z"};